module.exports = __webpack_public_path__ + "img/Logistica.b74313a5.png";